import { render, staticRenderFns } from "./EcommerceCategoriesChart.vue?vue&type=template&id=572b7809&"
import script from "./EcommerceCategoriesChart.vue?vue&type=script&lang=js&"
export * from "./EcommerceCategoriesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports